import React, { useEffect, useState } from "react";
import Auth from "../components/auth.component";
import { firebaseAuth } from "../firebaseConfig";
import { deleteUser, onAuthStateChanged } from "firebase/auth";
import { Container } from "../app.style";
import { Button, ButtonContainer } from "../components/form.style";

const DeleteAccountScreen = () => {
  const auth = firebaseAuth;
  const [user, setUser] = useState(null);

  const deleteAccount = () => {
    const confirm = window.confirm(
      "Bist du dir sicher, dass du dein Konto löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    );

    if (confirm) {
      const currentUser = auth.currentUser;
      deleteUser(currentUser)
        .then(() => {
          window.alert("Dein Konto wurde erfolgreich gelöscht");
        })
        .catch((error) =>
          window.alert(
            "Es ist ein Fehler beim Löschen des Kontos aufgetreten. " +
              error.toString(),
          ),
        );
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });
    return () => unsubscribe();
  }, [auth, user]);

  return (
    <main>
      <section>
        <Container>
          <h1>Konto löschen</h1>
          <p>
            Melde dich bei deinem KATAPULT-App Konto an, damit du dein Konto
            löschen kannst
          </p>
          {user ? (
            <>
              <h2>Danger Zone</h2>
              <p>
                Wie deine Daten gespeichert und verarbeitet werden, findest du
                in unseren <a href={"/datenschutz"}>Datenschutzbestimmungen</a>.
              </p>
              <ButtonContainer>
                <Button type={"button"} onClick={deleteAccount}>
                  Konto löschen
                </Button>
              </ButtonContainer>
            </>
          ) : (
            <Auth />
          )}
        </Container>
      </section>
    </main>
  );
};

export default DeleteAccountScreen;
